import type {CreateRepresentativeFormPayload} from "./create-representative.schema";

import {createRepresentative} from "@project/sdk/sales";
import {CreateRepresentativeBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../representative-keys";

import {createRepresentativeMapper} from "./create-representative.mapper";

export function createRepresentativeMutationOptions() {
  return mutationOptions({
    mutationFn: (payload: CreateRepresentativeFormPayload) =>
      createRepresentative(
        CreateRepresentativeBody.parse(createRepresentativeMapper.toSdk(payload)),
      ),
    mutationKey: representativeMutationKeys.createRepresentative,
    onSuccess: async (_representativeId, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: representativeKeys.lists()});
    },
  });
}
